import { FormControl, MenuItem, Select, makeStyles } from "@material-ui/core";
import axios from "axios";
import getSymbolFromCurrency from "currency-symbol-map";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { NODE_API_URL } from "../../../../env_config";

export default function MultiCurrency(props) {
    const id = useMemo(() => localStorage.getItem("C_id"), []);
    const consumerSessionCurrency = useMemo(() => localStorage.getItem("consumerSessionCurrency"), []);

    const { allowCurrencyChange, hidePrice } = useSelector(
        (state) => state.CcModeSettingReducer,
    );

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 110,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        menuItemScroll: {
            maxHeight: "200px",
            overflowY: "auto",
            backgroundColor: props?.themeData?.nav_bar_color
                ? props?.themeData?.nav_bar_color
                : "#fff",
        },
        select: {
            "&.Mui-disabled": {
                backgroundColor: "#e0e0e0",
                cursor: "not-allowed !important",
            },
        },
        menuItem: {
            "&:hover": {
                // backgroundColor: props?.themeData?.background_color ? props?.themeData?.background_color : '#000',
            },
            "&.Mui-selected": {
                // backgroundColor: props?.themeData?.background_color ? props?.themeData?.background_color : '#000',
            },
        },
        defaultCurrency: {
            border: props?.themeData?.nav_bar_font
                ? `1px solid ${props.themeData.nav_bar_font}`
                : "1px solid #000",
            paddingTop: "2px",
            paddingBottom: "2px",
        },
    }));

    const classes = useStyles();
    const [currency, setCurrency] = React.useState(null);
    const [currencies, setCurrencies] = React.useState([]);
    const userData = useMemo(() => localStorage.getItem("userData"), []);
    const user = JSON.parse(userData);

    const handleChange = async (event) => {
        try {
            setCurrency(event.target.value);
            await updateSelectedCurrencyOfUser(event.target.value, user.userId);
            console.log("Selected currency updated successfully");
            localStorage.setItem("user_currency", event.target.value);
            window.location.reload(false);
        } catch (error) { }
    };

    async function updateSelectedCurrencyOfUser(selectedCurrency, userId) {
        return axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/set-selected-currency`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: {
                selectedCurrency: selectedCurrency,
                userId: userId,
            },
        })
            .then((res) => {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }
            })
            .catch((err) => { });
    }

    useEffect(() => {
        // Fetch the latest currency data
        getCurrency();

        const defaultCurrency = props.themeData.Currency;

        if (props.themeData.selected_currency) {
            setCurrency(props.themeData.selected_currency);
            localStorage.setItem(
                "user_currency",
                props.themeData.selected_currency,
            );
        } else {
            setCurrency(defaultCurrency);
            localStorage.setItem("user_currency", defaultCurrency);
            updateSelectedCurrencyOfUser(defaultCurrency, user.userId);
        }
    }, [props.themeData]);

    function getCurrency() {
        const currencyData = { defaultCurrency: user.Currency };
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/fetch-allowed-currencies`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: currencyData,
        })
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    if (res.data.message === "UnAuthorized") {
                        localStorage.clear();
                        window.location.reload(true);
                    }
                    let currs = [];
                    for (let keys in res.data.data) {
                        if (!keys.includes("org")) {
                            currs.push({
                                currencyname: keys,
                                currencyvalue: res.data.data[keys],
                            });
                        }
                    }
                    // currs.push({
                    //     currencyname:"cur_usd",
                    //     currencyvalue:1
                    // })
                    setCurrencies(currs);
                }
            })
            .catch(function (res) {
                console.error(res);
            });
    }

    function currencyIcon() {
        const currencyCode = props.themeData.Currency;
        return getSymbolFromCurrency(currencyCode);
    }

    return id > 0 && consumerSessionCurrency ? (
        <div className={`px-8 ${classes.defaultCurrency}`}>
            <span className="font-size-h6 font-weight-bold">
                {currency} {getSymbolFromCurrency(currency)}
            </span>
        </div>
    ) : (
        <>
            {hidePrice || !allowCurrencyChange ? (
                <div className={`px-8 ${classes.defaultCurrency}`}>
                    <span className="font-size-h6 font-weight-bold">
                        {props.themeData.Currency} {currencyIcon()}
                    </span>
                </div>
            ) : (
                ""
            )}
            <div className="separator separator-solid"></div>
            {!hidePrice ? (
                allowCurrencyChange ? (
                    <div className="MultiLingual">
                        <FormControl className={classes.formControl}>
                            {currencies && currency ? (
                                <Select
                                    classes={{ root: classes.select }}
                                    labelId="MultiLingual"
                                    id="MultiLingual"
                                    value={currency}
                                    onChange={handleChange}
                                    variant="outlined"
                                    margin="dense"
                                    MenuProps={{
                                        classes: {
                                            paper: classes.menuItemScroll,
                                        },
                                    }}
                                    disabled={!!!allowCurrencyChange}
                                >
                                    {currencies.map((values, i) => (
                                        <MenuItem
                                            className={`c-header-menu ${classes.menuItem}`}
                                            key={i}
                                            value={values.currencyname
                                                .split("_")[1]
                                                .toUpperCase()}
                                        >
                                            {values.currencyname
                                                .split("_")[1]
                                                .toUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                ""
                            )}
                        </FormControl>
                    </div>
                ) : (
                    ""
                )
            ) : (
                ""
            )}
        </>
    );
}
